// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-2de40ce8] {\n  text-align: center;\n}\n.rightTop[data-v-2de40ce8] {\n  font-weight: bold;\n}\n.dayList[data-v-2de40ce8] {\n  height: 0.32rem;\n  margin-top: 0.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
